// Startbild «Netzplan»: Geometrie in Bildpunkten des Referenzfotos (1500 x 999).
//
// Von Hand gesetzt, nicht generiert. Alles liegt im selben Koordinatensystem wie das Foto
// (viewBox + preserveAspectRatio="xMidYMid slice"), damit die Zeichnung bei jedem
// Seitenverhaeltnis an derselben Stelle im Bild sitzt.
//
// ⚠️ Der Schleier deckt das untere Bilddrittel fast vollstaendig ab. Die Szene bleibt
// deshalb zwischen y 150 und y 530 - unterhalb davon waere sie nicht mehr zu lesen.
//
// ⚠️ Waagrecht beginnt die Szene erst bei x 200, nicht bei 130: Auf 5:4 wird das Bild
// SEITLICH beschnitten (je rund 125 Einheiten), und der erste Knoten stand dann auf der
// Kante. Der nutzbare Streifen ist etwa x 180 bis x 1320.
//
// Die Zahlen sind Schauwerte, keine echten Plandaten.

export const BILD_BREITE = 1500;
export const BILD_HOEHE = 999;

export interface Knoten {
    id: string;
    x: number;
    y: number;
    w: number;
    h: number;
    /** Dauer in Tagen, steht ueber der rechten oberen Ecke. */
    dauer: string;
    /** Liegt auf dem kritischen Weg - leuchtet auf. */
    kritisch: boolean;
}

const W = 200;
const H = 76;

export const KNOTEN: Knoten[] = [
    { id: "k1", x: 200,  y: 318, w: W, h: H, dauer: "2 T", kritisch: true },
    { id: "k2", x: 490,  y: 222, w: W, h: H, dauer: "5 T", kritisch: true },
    { id: "k3", x: 490,  y: 414, w: W, h: H, dauer: "3 T", kritisch: false },
    { id: "k4", x: 780,  y: 318, w: W, h: H, dauer: "8 T", kritisch: true },
    { id: "k5", x: 1070, y: 318, w: W, h: H, dauer: "4 T", kritisch: true },
];

export interface Kante {
    id: string;
    /** Rechtwinkliger Verbinder, wie in einem Vorgangsknotennetz ueblich. */
    d: string;
    /** Spitze am Zielknoten. */
    spitze: string;
    kritisch: boolean;
}

export const KANTEN: Kante[] = [
    { id: "e1", d: "M400 356 H445 V260 H484", spitze: "M484 252 L500 260 L484 268 Z", kritisch: true },
    { id: "e2", d: "M400 356 H445 V452 H484", spitze: "M484 444 L500 452 L484 460 Z", kritisch: false },
    { id: "e3", d: "M690 260 H735 V356 H774", spitze: "M774 348 L790 356 L774 364 Z", kritisch: true },
    { id: "e4", d: "M690 452 H735 V356 H774", spitze: "M774 348 L790 356 L774 364 Z", kritisch: false },
    { id: "e5", d: "M980 356 H1064",          spitze: "M1064 348 L1080 356 L1064 364 Z", kritisch: true },
];

/**
 * Der negative Puffer am unkritischen Zweig. Bewusst negativ: im Netzplan heisst das
 * „schon zu spaet", und genau darum geht es in dem Werkzeug. Ein Startbild, in dem alles
 * glatt durchlaeuft, wuerde es falsch beschreiben.
 * Farbe ist die des Werkzeugs selbst - seine Pufferskala faerbt alles <= 0 rot.
 */
export const PUFFER = {
    x: 490,
    y: 508,
    w: 138,
    h: 9,
    text: "-3 T",
    textX: 642,
    textY: 517,
};

/** Duenne Zeitachse ueber der Szene - der Netzplan rechnet in Kalenderwochen. */
/**
 * ⚠️ Beginnt bei x 250, NICHT bei 130 (dem linken Rand der Knoten): Bei x 130 lag die Marke
 * „KW 38" genau unter dem Eck-Winkel oben links. Erst im Bild gesehen, nicht im Kopf.
 */
export const ACHSE = {
    y: 172,
    x1: 320,
    x2: 1270,
    ticks: [320, 557.5, 795, 1032.5, 1270],
    marken: [
        { x: 320, text: "KW 38" },
        { x: 795, text: "KW 40" },
        { x: 1270, text: "KW 42" },
    ],
};
